import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/privacy")({
  head: () => ({
    meta: [
      { title: "Chính sách bảo mật — Ezyclass" },
      { name: "description", content: "Chính sách bảo mật của Ezyclass: cách chúng tôi thu thập, sử dụng, lưu trữ và bảo vệ dữ liệu cá nhân của trung tâm, giáo viên, học sinh và phụ huynh khi dùng hệ thống." },
      { property: "og:title", content: "Chính sách bảo mật — Ezyclass" },
      { property: "og:description", content: "Cách Ezyclass thu thập, sử dụng và bảo vệ dữ liệu cá nhân của trung tâm, giáo viên và học sinh." },
      { property: "og:url", content: "https://ezyclass.com/privacy" },
    ],
    links: [{ rel: "canonical", href: "https://ezyclass.com/privacy" }],
  }),

  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <main className="max-w-3xl mx-auto px-5 md:px-8 py-16 prose prose-slate">
      <Link to="/" className="text-sm text-blue-600 hover:underline no-underline">← Về trang chủ</Link>
      <h1 className="font-display">Chính sách bảo mật</h1>
      <p className="text-sm text-slate-500">Cập nhật lần cuối: 30/05/2026</p>

      <h2>1. Bên kiểm soát dữ liệu</h2>
      <p>
        <strong>Ezyclass</strong> (“Chúng tôi”) là bên kiểm soát dữ liệu (Data Controller) đối với
        dữ liệu cá nhân mà bạn cung cấp khi sử dụng Dịch vụ Ezyclass.
      </p>

      <h2>2. Dữ liệu chúng tôi thu thập</h2>
      <ul>
        <li><strong>Thông tin tài khoản</strong>: email, mật khẩu (mã hóa), tên hiển thị, vai trò.</li>
        <li><strong>Hồ sơ</strong>: số điện thoại, ngày sinh, địa chỉ, ảnh đại diện (nếu cung cấp).</li>
        <li><strong>Dữ liệu vận hành trung tâm</strong>: lớp học, học viên, điểm danh, bài tập, học phí, lương giáo viên — do admin của bạn nhập vào.</li>
        <li><strong>Dữ liệu kỹ thuật</strong>: địa chỉ IP, loại trình duyệt, hệ điều hành, thời điểm truy cập, log hệ thống.</li>
        <li><strong>Tin nhắn hỗ trợ</strong>: khi bạn liên hệ chúng tôi qua email.</li>
      </ul>
      <p>
        Lưu ý: thông tin thanh toán (số thẻ, tài khoản ngân hàng) được PayOS thu thập và xử lý
        trực tiếp — chúng tôi <strong>không lưu trữ</strong> dữ liệu thẻ của bạn.
      </p>

      <h2>3. Mục đích sử dụng</h2>
      <ul>
        <li>Tạo và duy trì tài khoản, cung cấp Dịch vụ.</li>
        <li>Quản lý thuê bao &amp; gia hạn.</li>
        <li>Bảo mật, phòng chống gian lận &amp; lạm dụng.</li>
        <li>Hỗ trợ khách hàng.</li>
        <li>Cải thiện sản phẩm dựa trên dữ liệu thống kê ẩn danh.</li>
        <li>Gửi thông báo dịch vụ qua email khi cần thiết.</li>
      </ul>

      <h2>4. Cơ sở pháp lý</h2>
      <p>
        Chúng tôi xử lý dữ liệu trên cơ sở: (a) thực hiện hợp đồng cung cấp Dịch vụ với bạn,
        (b) lợi ích chính đáng (bảo mật, cải thiện sản phẩm), (c) sự đồng ý của bạn khi áp dụng,
        (d) tuân thủ nghĩa vụ pháp lý.
      </p>

      <h2>5. Bên thứ ba chúng tôi chia sẻ dữ liệu</h2>
      <ul>
        <li>
          <strong>PayOS</strong> — Merchant of Record xử lý thanh toán, hóa đơn, thuế và hoàn
          tiền. Xem{" "}
          <a href="https://payos.vn" target="_blank" rel="noopener noreferrer">
            Chính sách bảo mật PayOS
          </a>
          .
        </li>
        <li>
          <strong>Nhà cung cấp hạ tầng</strong> — Supabase / Cloudflare cho lưu trữ và vận hành
          ứng dụng.
        </li>
        <li><strong>Cơ quan nhà nước</strong> — khi có yêu cầu hợp pháp.</li>
      </ul>
      <p>Chúng tôi <strong>không bán</strong> dữ liệu cá nhân cho bên thứ ba.</p>

      <h2>6. Lưu trữ dữ liệu</h2>
      <p>
        Dữ liệu được lưu trong suốt thời gian bạn còn là khách hàng. Khi tài khoản chấm dứt, dữ
        liệu sẽ bị xóa hoặc ẩn danh trong vòng 90 ngày, trừ khi pháp luật yêu cầu lưu lâu hơn
        (ví dụ: hồ sơ thuế, hóa đơn).
      </p>

      <h2>7. Quyền của bạn</h2>
      <ul>
        <li>Quyền truy cập &amp; xem dữ liệu cá nhân của mình.</li>
        <li>Quyền yêu cầu chỉnh sửa thông tin sai sót.</li>
        <li>Quyền yêu cầu xóa tài khoản &amp; dữ liệu.</li>
        <li>Quyền yêu cầu xuất dữ liệu ở định dạng có thể đọc được.</li>
        <li>Quyền khiếu nại với cơ quan bảo vệ dữ liệu có thẩm quyền.</li>
      </ul>
      <p>
        Để thực hiện quyền của bạn, vui lòng gửi email tới{" "}
        <a href="mailto:contact@ezyclass.com">contact@ezyclass.com</a>. Chúng tôi sẽ phản hồi trong
        vòng 30 ngày.
      </p>

      <h2>8. Bảo mật</h2>
      <p>
        Chúng tôi áp dụng các biện pháp kỹ thuật và tổ chức phù hợp: mã hóa truyền tải (HTTPS/TLS),
        mã hóa mật khẩu (bcrypt), kiểm soát truy cập theo vai trò (RLS), sao lưu định kỳ, ghi log
        hệ thống.
      </p>

      <h2>9. Cookie</h2>
      <p>
        Chúng tôi chỉ sử dụng cookie thiết yếu để duy trì phiên đăng nhập và đảm bảo bảo mật.
        Không sử dụng cookie tracking quảng cáo.
      </p>

      <h2>10. Liên hệ</h2>
      <p>
        Mọi câu hỏi về chính sách bảo mật xin gửi tới{" "}
        <a href="mailto:contact@ezyclass.com">contact@ezyclass.com</a>.
      </p>
    </main>
  );
}
